/**
 * Pickup Demo Section - Video Filter Functionality
 * Simple filtering without AJAX
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickupDemo);
  } else {
    initPickupDemo();
  }

  function initPickupDemo() {
    // Get all filter buttons
    const filterBtns = document.querySelectorAll('.filter-btn');
    // Get all video cards
    const videoCards = document.querySelectorAll('.video-card');
    
    // If no elements found, exit
    if (!filterBtns.length || !videoCards.length) {
      console.log('No filter buttons or video cards found');
      return;
    }

    // console.log('Found ' + filterBtns.length + ' filter buttons and ' + videoCards.length + ' video cards');

    // Add click event to each filter button
    filterBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        
        // console.log('Filter button clicked:', this.dataset.filter);
        
        // Remove active class from all buttons
        filterBtns.forEach(function(b) {
          b.classList.remove('active');
          b.classList.add('btn-secondary');
        });
        
        // Add active class to clicked button
        this.classList.add('active');
        this.classList.remove('btn-secondary');
        
        // Get the filter value
        const filterValue = this.dataset.filter;
        
        // Filter video cards
        filterVideoCards(videoCards, filterValue);
      });
    });

    // Initially show 'All Videos' view
    const allBtn = document.querySelector('.filter-btn[data-filter="all"]');
    if (allBtn) {
      allBtn.click();
    }
  }

  /**
   * Filter video cards based on selected category
   * @param {NodeList} cards - Collection of video card elements
   * @param {string} filterValue - The category to filter by ('all' or specific category)
   */
  function filterVideoCards(cards, filterValue) {
    let visibleCount = 0;
    
    cards.forEach(function(card) {
      const cardCategory = card.dataset.category;
      let shouldShow = false;
      
      if (filterValue === 'all') {
        // Show only videos marked as visible in 'All' view
        const showInAll = card.dataset.showInAll === 'true';
        shouldShow = showInAll;
      } else {
        // Show only cards from the selected category
        shouldShow = (cardCategory === filterValue);
      }
      
      card.style.display = shouldShow ? 'block' : 'none';
      if (shouldShow) {
        visibleCount++;
      }
    });
    
    // console.log('Showing ' + visibleCount + ' videos for filter: ' + filterValue);
  }
})();